<template>
  <div>
    <Title :pages="[{ icon: 'box', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <v-btn flat class="mb-3 btn-second" @click="updateDialog(true)">Crear {{ modal_title }}</v-btn>
      <v-btn outlined class="ml-3 mb-3 btn-third" @click="updateDialogImportProduct(true)" v-if="!isClient()">Importar {{ modal_title }}</v-btn>

      <Modal
        :create_access="create_access"
        :button_name="'Crear ' + modal_title"
        :modal_title="modal_title"
        :page_title="page_title"
        :formBtn="formBtn"
        :dialog="dialog"
        :service="service"
        @updateDialog="updateDialog"
        @loadList="loadList(service)"
        :editItem="mainItem"
      />

      <ModalImportProduct
        v-if="create_access"
        :page_title="page_title"
        :dialog="dialog_import_product"
        :service="service"
        @updateDialog="updateDialogImportProduct"
        @loadList="loadList(service)"
      />


      <v-card class="mb-4">
        <div class="row mb-2 ps-3 pe-3 mt-0 mb-2">
          <div class="col-md-12">
            <div class="col-md-12" style="background: white">
              <p class="text-h6 mt-2 mb-0"><font-awesome-icon icon="filter" class="pr-2" />Filtros</p>
              <v-divider class="mt-0"></v-divider>
              <div class="row pt-2">
                <div class="col-md-3">
                  <v-combobox
                    v-model="filters.client"
                    density="comfortable"
                    name="client"
                    item-title="name"
                    item-value="id"
                    :items="clients"
                    label="Cliente"
                    autocomplete="off"
                    :disabled="disabled"
                    clearable
                    @update:modelValue="onClientChange"
                  ></v-combobox>
                </div>
                <div class="col-md-3">
                  <v-combobox
                    v-model="filters.category"
                    density="comfortable"
                    name="category"
                    item-title="name"
                    item-value="id"
                    :items="categories"
                    label="Rubro"
                    autocomplete="off"
                    :disabled="disabled"
                    clearable
                  ></v-combobox>
                </div>
                <div class="col-md-3">
                  <v-text-field
                    v-model="filters.sku"
                    density="comfortable"
                    label="SKU"
                    placeholder="Buscar por SKU..."
                    :disabled="disabled"
                    clearable
                  ></v-text-field>
                </div>
                <div class="col-md-3">
                  <v-text-field
                    v-model="filters.barcode"
                    density="comfortable"
                    label="Código de Barra"
                    placeholder="Buscar por código de barra..."
                    :disabled="disabled"
                    clearable
                  ></v-text-field>
                </div>
                <div class="col-md-3">
                  <v-combobox
                    v-model="filters.product"
                    density="comfortable"
                    name="product"
                    item-title="label"
                    item-value="id"
                    :items="products_minify"
                    label="Producto"
                    autocomplete="off"
                    :disabled="disabled"
                    :loading="loading_products"
                    clearable
                  ></v-combobox>
                </div>

                <div class="col-md-3">
                  <v-combobox
                    v-model="filters.status"
                    density="comfortable"
                    name="status"
                    item-title="name"
                    item-value="id"
                    :items="states"
                    label="Estado"
                    autocomplete="off"
                    :disabled="disabled"
                    clearable
                  ></v-combobox>
                </div>

                <div class="col-md-6 mb-4" style="display: flex; justify-content: end">
                  <v-btn color="blue-grey" class="mr-3" small dark :loading="dialog_export" @click="exportFile()"> Exportar <font-awesome-icon class="ml-2" icon="download" /></v-btn>

                  <v-btn color="info" class="" @click="filter" prepend-icon="mdi-magnify">Buscar</v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card>

      <v-card v-if="list_access">
        <v-card-title>
          <v-row align="center" class="mt-1">
            <v-col>
              <span>{{ page_title }}</span>
            </v-col>
            <v-spacer></v-spacer>
            <v-col>
              <v-text-field v-model="search" append-inner-icon="mdi-magnify" single-line hide-details label="Buscar" density="compact"></v-text-field>
            </v-col>
          </v-row>
        </v-card-title>

        <v-data-table :items-per-page="0" :headers="headers" :items="list" :search="search" :loading="loading" loading-text="Cargando..." :hide-default-footer="true">
          <template v-slot:item="{ item }">
            <tr>
              <td>{{ item.sku }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.client.name }}</td>
              <td>{{ item.category != null ? item.category.name : "-" }}</td>
              <td>{{ item.subcategory != null ? item.subcategory.name : "-" }}</td>
              <td>{{ item.product_type != null ? item.product_type.name : "-" }}</td>
              <td>
                <v-chip :color="service.getCompletitudColor(item.status)" size="small">
                  {{ service.getCompletitudName(item.status) }}
                </v-chip>
              </td>
              <td class="text-center" style="width: 150px">
                <v-tooltip bottom v-if="item.status != service.PRODUCT_COMPLETITUD_INCOMPLETO">
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props" small color="purple" class="mr-2" v-on:click="print(item)" size="small"> mdi-printer</v-icon>
                  </template>
                  <span>Imprimir</span>
                </v-tooltip>

                <v-tooltip bottom v-if="!isClient()">
                  <template v-slot:activator="{ props }">
                    <v-icon v-if="update_access" v-bind="props" small color="blue" class="mr-2" v-on:click="editItem(item)" size="small"> mdi-pencil</v-icon>
                  </template>
                  <span>Editar</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props" small color="blue" class="mr-2" v-on:click="viewItem(item)" size="small"> mdi-eye </v-icon>
                  </template>
                  <span>Ver</span>
                </v-tooltip>

                <v-tooltip bottom v-if="!isClient()">
                  <template v-slot:activator="{ props }">
                    <v-icon v-if="delete_access" v-bind="props" small color="red" class="mr-2" v-on:click="deleteItem(item)" size="small">mdi-delete </v-icon>
                  </template>
                  <span>Eliminar</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>

       
      <div class="text-right mt-2">
        <small class="text-grey">
          {{ paginationText }}
        </small>
      </div>
      <v-pagination
        v-if="cant_pages > 1"
        v-model="current_page"
        :length="cant_pages"
        total-visible="10"
        @update:modelValue="loadPage(service)"
        class="mt-4"
      ></v-pagination>

      <ModalPrint :show="dialog_print" @close="dialog_print = false" :selected="selected" :list="list" @cleanSelected="selected = []" :presentations="presentations" />

      <DialogDelete :dialog_delete="dialog_delete" @updateDialogDelete="updateDialogDelete" @deleteItemConfirm="deleteItemConfirm" :loading="loadingSubmit" />
    </v-container>
  </div>
</template>

<script>
import { productoService } from "@/libs/ws/productoService";
import GenericMixin from "@/mixins/GenericMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import ExportMixin from "@/mixins/ExportMixin.vue";
import Modal from "./Modal.vue";
import ModalPrint from "./ModalPrint.vue";
import ModalImportProduct from "./ModalImportProduct.vue";
import { clientService } from "@/libs/ws/clientService";
import { rubroService } from "@/libs/ws/rubroService";


export default {
  components: { Modal, ModalPrint, ModalImportProduct },
  mixins: [GenericMixin, RolMixin, ExportMixin],
  RolMixin,
  data() {
    return {
      service: productoService,
      page_title: "Productos",
      modal_title: "Producto",
      dialog_print: false,
      selected: [],
      presentations: [],
      clients: [],
      categories: [],
      products_minify: [],
      loading_products: false,
      states: productoService.COMPLETITUD_STATES,
      filters: {
        sku: "",
        barcode: "",
        product: null,
        client: null,
        category: null,
        status: null,
      },
      headers: [
        {
          title: "SKU",
          align: "left",
          sortable: true,
          key: "sku",
        },
        {
          title: "Nombre",
          align: "left",
          sortable: true,
          key: "name",
        },
        {
          title: "Cliente",
          align: "left",
          sortable: true,
          key: "client.name",
        },
        {
          title: "Rubro",
          align: "left",
          sortable: true,
          key: "category.name",
        },
        {
          title: "Subrubro",
          align: "left",
          sortable: true,
          key: "subcategory.name",
        },
        {
          title: "Tipo de Producto",
          align: "left",
          sortable: true,
          key: "product_type.name",
        },
        {
          title: "Estado",
          align: "left",
          sortable: true,
          key: "status",
        },
        { title: "Accion", align: "center", sortable: false, key: "" },
      ],
      dialog_import_product: false,
    };
  },
  mounted() {
    this.loadList(this.service);
    this.loadClients();
    this.loadCategories();
    this.loadProductsMinify();
  },
  methods: {
    updateDialogImportProduct(value) {
      if (!value) {
        this.close();
      }
      this.dialog_import_product = value;
    },
    print(item) {
      this.selected = [];
      this.selected.push(item.id);
      this.presentations = item.presentations;
      this.dialog_print = true;
    },
    filter() {
      this.current_page = 1;
      this.loadList(this.service);
    },
    exportFile() {
      var param = { ...this.getFilterParams() }; // Copia de this.filters
      param["export"] = true;
      this.exportExcel("products/list", param, "Productos.xlsx");
    },
    getFilterParams() {
      return this.filters;
    },
    loadClients() {
      clientService
        .filter({})
        .then((response) => {
          this.clients = response.result.list;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        });
    },
    loadCategories() {
      rubroService
        .filter()
        .then((response) => {
          console.log("categorias", response.result);
          this.categories = response.result.list;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        });
    },
    loadProductsMinify(client_id = null) {
      this.loading_products = true;
      
      //Esta pantalla es la unica que tiene que poder filtrar por productos incompletos:
      //el resto de los comboboxes del sistema solo ve los completos.
      const params = { include_incomplete: true };
      if (client_id) {
        params.client = { id: client_id };
      }
      
      productoService
        .list_minify(params)
        .then((response) => {
          this.products_minify = response.result.list;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        })
        .finally(() => {
          this.loading_products = false;
        });
    },
    onClientChange(client) {
      this.filters.product = null;
      
      if (client && client.id) {
        this.loadProductsMinify(client.id);
      } else {
        this.loadProductsMinify();
      }
    },
  },
};
</script>
